export default __webpack_public_path__ + "static/media/powerOnButton.5d4f8dba.png";